import axios from "axios";
import { env } from "../../config/config";

const api = axios.create({
  baseURL: env.API_SERVER + "/api",
});

export const fetchWithToken = async (endpoint, method = "GET", data = null) => {
  const token = localStorage.getItem("post-plant-token");

  try {
    const response = await api({
      method: method,
      url: endpoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
    });

    return response.data;
  } catch (error) {
    console.error("API call error:", error.response || error);
    throw error;
  }
};

export const fetchWithoutToken = async (
  endpoint,
  method = "GET",
  data = null
) => {
  try {
    const response = await api({
      method: method,
      url: endpoint,
      data: data,
    });

    return response.data;
  } catch (error) {
    console.error("API call error:", error.response || error);
    throw error;
  }
};
